<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_profile"
      persistent
      :max-width="width"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 pb-0">
          <v-container style="height: max-content">
            <edit-expertise-tf
              v-if="type == 'u_expertiseTF'"
              @success="closeAndFetch"
              @close="$emit('close')"
              :inventory="inventory"
            />
            <edit-tf-contact
              v-if="type == 'u_contactTF'"
              @success="closeAndFetch"
              @close="$emit('close')"
              :inventory="inventory"
            />
            <update-bio
              v-if="type == 'u_bio'"
              @success="closeAndFetch"
              @close="$emit('close')"
              :inventory="inventory"
            />
            <edit-tf-profile
              v-if="type == 'u_profileTF'"
              @success="closeAndFetch"
              @close="$emit('close')"
              :inventory="inventory"
            />
            <edit-profile-scholar-per-key
              v-if="type == 'u_profileScholarPerKey'"
              @success="closeAndFetch"
              @close="$emit('close')"
              :inventory="inventory"
            />
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import EditExpertiseTf from "./tf/editExpertiseTf.vue";
import EditTfContact from "./tf/editTfContact.vue";
import EditTfProfile from "./tf/editTfProfile.vue";
import UpdateBio from "./tf/updateBio.vue";
import EditProfileScholarPerKey from "./scholar/editProfileScholarPerKey.vue";
export default {
  components: { EditExpertiseTf, EditTfContact, UpdateBio, EditTfProfile ,EditProfileScholarPerKey},
  name: "dialogUP",
  props: ["d_profile", "type", "title", "inventory", "width"],
  methods: {
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>